module.exports = __webpack_public_path__ + "static/media/WordsHavePower_p14-15.2a7c35cc.jpg";